"use client";

import { Redo, Undo } from "lucide-react";
import { cn } from "../../lib";

export type MediaPlayerSkipDirection = "back" | "forward";

export interface MediaPlayerSkipLabelProps {
	direction: MediaPlayerSkipDirection;
	skipIntervalSeconds: number;
	iconClassName?: string;
	/** Icon + seconds label colours (defaults to `text-current` from the parent button). */
	toneClassName?: string;
	className?: string;
}

/** Undo/redo icon shifted above center with skip seconds beneath (topic learner transport). */
export function MediaPlayerSkipLabel({
	direction,
	skipIntervalSeconds,
	iconClassName,
	toneClassName = "text-current",
	className,
}: MediaPlayerSkipLabelProps) {
	const Icon = direction === "back" ? Undo : Redo;

	return (
		<span
			className={cn(
				"inline-flex flex-col items-center justify-center gap-0 leading-none",
				className,
			)}
		>
			<Icon
				className={cn(iconClassName, toneClassName, "-translate-y-0.5")}
				strokeWidth={2.25}
				aria-hidden
			/>
			<span
				className={cn(
					"font-black text-[10px] tabular-nums leading-none",
					toneClassName,
				)}
			>
				{skipIntervalSeconds}
			</span>
		</span>
	);
}
